import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useCacheBuster } from 'react-cache-buster';
import { QueryClient, QueryClientProvider } from 'react-query';
// mui
import { ThemeProvider } from '@mui/material';
import CheckCircleOutlineRoundedIcon from '@mui/icons-material/CheckCircleOutlineRounded';
import CssBaseline from '@mui/material/CssBaseline';
// common
import Router from './common/route/Router';
import RouterList from './common/route/RouterList';
import { SFToastContainer } from '@/component/common/sf-toast-container';
// asset & font
import theme from '@/theme';
import { Global, css } from '@emotion/react';
import fontsStyle from '@/assets/fonts/fonts';
// provider
import { CacheProvider } from '@emotion/react';
import createEmotionCache from '@/createEmotionCache';
// lib
import { setStorage } from './lib/storage';
import { urlSessionStorage } from './lib/storage';
import { changeLang } from './lib/util';
import { SessionRefresh } from './lib/web3Auth/SessionRefresh';
// etc
import packageJson from '../package.json'; // '../package.json';
import ReactGA from 'react-ga';
import 'react-toastify/dist/ReactToastify.css';
// import { useWeb3 } from './hooks/use-web3';
import { setPoolInfo } from './store/reducers/poolInfo';

// import './index.css';
import { RecoilRoot } from 'recoil';

const emotionCache = createEmotionCache();
const queryClient = new QueryClient();

export default function App() {
  const version = packageJson.version;
  const { checkCacheStatus } = useCacheBuster();

  // const { web3authCall } = useWeb3();

  const dispatch = useDispatch();
  useEffect(() => {
    console.log(`version: ${version}`);
    checkCacheStatus();

    return () => {};
  }, [checkCacheStatus]);

  // useEffect(() => {
  //   (async () => {
  //     if (web3authCall?.connected()) {
  //       await connectWeb3auth();
  //       // const pools = await getAllPools();
  //       // await web3authCall.getStakingCall().setStakingContract(pools);
  //       // setAssetList(pools);
  //     }
  //   })();
  //   return () => {};
  // }, [web3authCall]);

  // const connectWeb3auth = async () => {
  //   console.log(`App web3authCall connected`);
  //   const pools: string[] = await web3authCall!.getStakingCall().getAllPools();
  //   await web3authCall!.getStakingCall().setStakingContract(pools);
  //   dispatch(setPoolInfo(pools));
  // };

  // ----- 새로고침 막기 변수 -----
  // const preventClose = (e: BeforeUnloadEvent) => {
  //   e.preventDefault();
  //   e.returnValue = ''; // chrome에서는 설정이 필요해서 넣은 코드
  // };

  // // 브라우저에 렌더링 시 한 번만 실행하는 코드
  // useEffect(() => {
  //   (() => {
  //     window.addEventListener('beforeunload', preventClose);
  //   })();

  //   return () => {
  //     window.removeEventListener('beforeunload', preventClose);
  //   };
  // }, []);
  // // ----- 새로고침 막기 변수 end -----

  // const userLang = navigator.language;
  // const lang = changeLang(userLang);
  // const langPayload = {
  //   key: 'lang',
  //   value: { lang },
  // };
  // setStorage(langPayload);

  const location = useLocation();
  const path = location.pathname;
  // const type = RouterList().find((item: any) => item.url === path);
  // if (type?.url) {
  //   const beForeUrl = urlSessionStorage().url;
  //   let url = beForeUrl !== '/signIn' ? beForeUrl : type.url;
  //   const payload = {
  //     key: 'url',
  //     value: { url },
  //   };
  //   setStorage(payload);
  // }

  // if (process.env.NODE_ENV === 'production') {
  //   let device = null;
  //   if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
  //     // 모바일인 경우
  //     device = 'mobile';
  //   } else {
  //     device = 'other';
  //   }
  //   ReactGA.set({ hitType: device, page: path });
  //   ReactGA.pageview(path);
  // }

  // if (projectId === undefined) {
  //   alert('project ID undefined');
  //   return <>error project ID</>;
  // }

  return (
    <div className="App">
      <SFToastContainer
        closeButton={false}
        hideProgressBar
        position="top-center"
        style={{
          paddingLeft: '24px',
          paddingRight: '24px',
          top: '50px',
        }}
        icon={
          <CheckCircleOutlineRoundedIcon
            sx={{
              fontSize: '16px',
            }}
          />
        }
      />
      <QueryClientProvider client={queryClient}>
        <CacheProvider value={emotionCache}>
          <ThemeProvider theme={theme}>
            <RecoilRoot>
              <CssBaseline />
              <SessionRefresh>
                <Router path={path} />
              </SessionRefresh>
            </RecoilRoot>
          </ThemeProvider>
          <Global
            styles={css`
              ${fontsStyle}
            `}
          />
        </CacheProvider>
      </QueryClientProvider>
    </div>
  );
}
